module.exports = __webpack_public_path__ + "img/icon-restaurant-mini-income.5abcfcae.png";